import { fromUnixTime } from "date-fns";

const STAFF_SESSION_UUID_KEY = "staff_session";
const STAFF_SESSION_TIMESTAMP_KEY = "staff_session_expires_at";

export type StaffSession = {
  uuid: string;
  expires: Date;
};

export function initStaffSession(): void {
  const url = new URL(window.location.href);
  const uuid = url.searchParams.get("staff_session");
  const timestamp = url.searchParams.get("staff_session_expires_at");
  if (uuid && timestamp) {
    sessionStorage.setItem(STAFF_SESSION_UUID_KEY, uuid);
    sessionStorage.setItem(STAFF_SESSION_TIMESTAMP_KEY, timestamp);
    url.searchParams.delete("staff_session");
    url.searchParams.delete("staff_session_expires_at");
    window.history.replaceState({}, "", url);
  }
}

export function exitStaffSession(): void {
  sessionStorage.removeItem(STAFF_SESSION_UUID_KEY);
  sessionStorage.removeItem(STAFF_SESSION_TIMESTAMP_KEY);
  window.location.assign("/admin");
}

export function getStaffSession(): StaffSession | null {
  const uuid = sessionStorage.getItem(STAFF_SESSION_UUID_KEY);
  const timestamp = sessionStorage.getItem(STAFF_SESSION_TIMESTAMP_KEY);
  if (uuid && timestamp) {
    return { uuid, expires: fromUnixTime(Number(timestamp)) };
  }
  return null;
}
